<template>
  <div id="city-header">
    <v-row>
      <v-col class="cityName">
        <h2>{{ city }}</h2>

        <div v-if="isFullAdmin || user.grupo.nome == 'Operações'">
          <combobox-municipio
            @onChange="onChangeMunicipio"
          ></combobox-municipio>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!sumirHeader()">
      <v-col>
        <v-bottom-navigation
          :value="activeBtn"
          color="primary"
          class="navigationHeader"
        >
          <v-divider vertical></v-divider>

          <v-btn :to="'/cidade/' + cityId + '/geral'">
            <span>Geral</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.acompanhamentos && groupsConfig.acompanhamentos)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/acompanhamento'"
            v-if="
              isFullAdmin ||
              ((isIndicadores || !isIndicadores) &&
                config.acompanhamentos &&
                groupsConfig.acompanhamentos)
            "
          >
            <span>Acompanhamentos</span>
          </v-btn>

          <v-divider
            v-if="isFullAdmin || (groupsConfig.evidencias && config.evidencias)"
            vertical
          ></v-divider>

          <v-btn
            :to="`${
              isSala
                ? '/cidade/' + cityId + '/evidencia/boasvindas'
                : '/cidade/' + cityId + '/evidencia/respondida'
            }`"
            v-if="isFullAdmin || (groupsConfig.evidencias && config.evidencias)"
          >
            <span>Evidências</span>
          </v-btn>
          <template v-if="podeVerRecursos">
            <v-divider
              v-if="recursosFechamento || isFullAdmin || (groupsConfig.recursos && config.recursos)"
              vertical
            ></v-divider>

            <v-btn
              :to="'/cidade/' + cityId + '/recursos'"
              v-if="recursosFechamento || isFullAdmin || (groupsConfig.recursos && config.recursos)"
            >
              <span>Recursos</span>
            </v-btn>
          </template>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.termoReferencia && groupsConfig.termoReferencia)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/revisoes-tecnicas'"
            v-if="
              isFullAdmin ||
              (groupsConfig.revisaoTecnica && config.revisaoTecnica)
            "
          >
            <span>Revisões técnicas</span>
          </v-btn>

          <v-divider
            v-if="isMtCidadeEmpreendedora && podeVerMenuProposta"
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/proposta/proposta'"
            v-if="isMtCidadeEmpreendedora && podeVerMenuProposta"
          >
            <span>Proposta</span>
          </v-btn>

          <v-divider
            v-if="
              isFullAdmin ||
              (config.termoReferencia && groupsConfig.termoReferencia)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/termo-referencia/0'"
            v-if="
              isFullAdmin ||
              (config.termoReferencia && groupsConfig.termoReferencia)
            "
          >
            <span>{{ labelMenuTermoReferencia }}</span>
          </v-btn>

          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA || (config.grupos && groupsConfig.grupos)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/grupo'"
            v-if="isFullAdmin || (config.grupos && groupsConfig.grupos)"
          >
            <span>{{
              $store.state.uf === "AL" || isAT
                ? "Grupos/Iniciativas"
                : isGov
                ? "Etapas/Grupos"
                : "Grupos"
            }}</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.calendario && groupsConfig.calendario)"
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evento'"
            v-if="isFullAdmin || (config.calendario && groupsConfig.calendario)"
          >
            <span>{{ isGov ? "Agenda" : "Calendário" }}</span>
          </v-btn>
          <v-divider
            v-if="
              estado === 'SC1' && (isAdmin || isConsultorEspecialistaMunicipio)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evento-em-lote'"
            v-if="
              estado === 'SC1' && (isAdmin || isConsultorEspecialistaMunicipio)
            "
          >
            <span>Calendário em Lote</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.relatorios && groupsConfig.relatorios)"
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/relatorio'"
            v-if="isFullAdmin || (config.relatorios && groupsConfig.relatorios)"
          >
            <span>Relatórios</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/relatorio-administrativo'"
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
          >
            <span>Relatório Administrativo</span>
          </v-btn>
          <v-divider
            v-if="
              !isMtCidadeEmpreendedora &&
              (isFullAdmin ||
                (config.verMenuProposta && groupsConfig.verMenuProposta))
            "
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/proposta/proposta'"
            v-if="
              !isMtCidadeEmpreendedora &&
              (isFullAdmin ||
                (config.verMenuProposta && groupsConfig.verMenuProposta))
            "
          >
            <span>Proposta</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.andamento && groupsConfig.andamento)"
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/andamento'"
            v-if="isFullAdmin || (config.andamento && groupsConfig.andamento)"
          >
            <span>Andamento</span>
          </v-btn>

          <v-divider
            v-if="isFullAdmin || (config.sala && groupsConfig.sala)"
            vertical
          ></v-divider>
          <v-btn
            v-if="isFullAdmin || (config.sala && groupsConfig.sala)"
            :to="'/sala-municipio-principal'"
          >
            <span>Sala</span>
          </v-btn>
          <v-divider vertical></v-divider>
          <template v-if="podeVerClienteOculto">
            <v-btn
              :to="`/cidade/${cityId}/cliente-oculto/info`"
              v-if="
                isFullAdmin ||
                (config.verClienteOculto && groupsConfig.verClienteOculto)
              "
            >
              <span>Cliente Oculto</span>
            </v-btn>
          </template>
        </v-bottom-navigation>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComboboxMunicipio from "./ComboboxMunicipio.vue";
import { cityAPI } from "../API/CityAPI";
import { atualUfDefinition } from "@/helpers/utils";

export default {
  components: { ComboboxMunicipio },
  props: {
    payload: { type: Object },
  },
  data() {
    return {
      activeBtn: 0,
      estado: this.$store.state.uf,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  watch: {
    "$route.params.municipioId": {
      immediate: true,
      async handler(id) {
        if (!(this.config && this.config.fechamentoSelo) ||
            !this.$route.path.includes('/revisoes-tecnicas') || !id) return;
        this.$store.dispatch('setCityId', Number(id));
        this.$store.dispatch('setCityName', '');
        try {
          const { data } = await cityAPI.get(id);
          if (String(this.$route.params.municipioId) === String(id)) {
            this.$store.dispatch('setCityName', data.nome);
          }
        } catch (_) {
          this.$notification.error('Erro ao obter a instituição da revisão técnica.');
        }
      },
    },
  },
  methods: {
    onChangeMunicipio(e) {
      this.$router.replace(`/cidade/${e}`);
      this.$emit("realod");
    },
    sumirHeader() {
      const acompanhamento =
        this.config.acompanhamentos && this.groupsConfig.acompanhamentos;
      const relatorios = this.config.relatorios && this.groupsConfig.relatorios;
      const calendario = this.config.calendario && this.groupsConfig.calendario;
      const evidencias = this.config.evidencias && this.groupsConfig.evidencias;
      const recursos = this.config.recursos && this.groupsConfig.recursos;
      const andamento = this.config.andamento && this.groupsConfig.andamento;
      const TR =
        this.config.termoReferencia && this.groupsConfig.termoReferencia;

      const relatorioAdmin =
        this.config.relatorioAdministrativo &&
        this.groupsConfig.relatorioAdministrativo;

      const sala = this.config.sala && this.groupsConfig.sala;
      const grupos = this.config.grupos && this.groupsConfig.grupos;
      const proposta =
        this.config.verMenuProposta && this.groupsConfig.verMenuProposta;
      const clienteOculto =
        this.config.verClienteOculto && this.groupsConfig.verClienteOculto;

      if (
        !this.isFullAdmin &&
        !acompanhamento &&
        !relatorios &&
        !calendario &&
        !evidencias &&
        !recursos &&
        !andamento &&
        !TR &&
        !relatorioAdmin &&
        !sala &&
        !grupos &&
        !proposta &&
        !clienteOculto
      ) {
        return true;
      }

      return false;
    },
  },
  computed: {
    isMtCidadeEmpreendedora() {
      return this.uf === "MT" && this.isCE;
    },
    labelMenuTermoReferencia() {
      if (this.isGov) return "Fases/Atividades";
      return this.isMtCidadeEmpreendedora
        ? "Soluções em Execução"
        : "Termos de Referência";
    },
    podeVerMenuProposta() {
      return (
        this.isFullAdmin ||
        (this.config.verMenuProposta && this.groupsConfig.verMenuProposta)
      );
    },
    podeVerRecursos() {
      return (
        this.recursosFechamento ||
        this.isFullAdmin ||
        (this.config.verSomenteRecursosOuro &&
          this.groupsConfig.verSomenteRecursosOuro &&
          !this.cidadeNaoOuro) ||
        (!this.config.verSomenteRecursosOuro &&
          !this.groupsConfig.verSomenteRecursosOuro) ||
        (this.config.verSomenteRecursosOuro &&
          !this.groupsConfig.verSomenteRecursosOuro) ||
        (!this.config.verSomenteRecursosOuro &&
          this.groupsConfig.verSomenteRecursosOuro)
      );
    },
    recursosFechamento() { return this.isSala && this.config && this.config.fechamentoSelo === true; },
    podeVerClienteOculto() {
      return (
        this.isFullAdmin ||
        (this.config.naoVerClienteOcultoOuro &&
          this.groupsConfig.naoVerClienteOcultoOuro &&
          this.cidadeNaoOuro) ||
        (!this.config.naoVerClienteOcultoOuro &&
          !this.groupsConfig.naoVerClienteOcultoOuro) ||
        (this.config.naoVerClienteOcultoOuro &&
          !this.groupsConfig.naoVerClienteOcultoOuro) ||
        (!this.config.naoVerClienteOcultoOuro &&
          this.groupsConfig.naoVerClienteOcultoOuro)
      );
    },
    cidadeNaoOuro() {
      return (
        this.payload &&
        this.payload.seloFinal &&
        this.payload.seloFinal.length > 0 &&
        this.payload.seloFinal[0].selo != "Ouro"
      );
    },
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "city",
      "uf",
      "cityId",
      "urlTag",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin",
      "isNA",
      "isIndicadores",
      "isSala",
      "isAT",
      "isGov",
      "isCE",
    ]),
  },
};
</script>

<style lang="scss">
.navigationHeader {
  .v-btn--active {
    background-color: var(--corPrimaria) !important;
    span {
      color: #fff;
    }
  }
}

.cityName {
  display: flex;
  align-items: center;
  column-gap: 2rem;
}
</style>
